module.exports = __webpack_public_path__ + "img/25.18c776da.png";